import {getCookieValue, removeCookie, saveCookieValue} from '../../api/helpers/cookieHelper';
import {useStorage} from '@vueuse/core';

/**
 * Creates a ref that is synced to a cookie.
 */
export function useCookie<T>(key: string, initialValue: T) {
    return useStorage(key, initialValue, {
        getItem(key) {
            return getCookieValue(key);
        },
        setItem(key, value) {
            saveCookieValue(key, value);
        },
        removeItem(key) {
            removeCookie(key);
        },
    });
}
